import Avatar from '@mui/material/Avatar';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export interface AchievementItemProps {
  value: number | string;
  title: string;
  icon: React.ReactNode;
}

export function AchievementItem({ value, title, icon }: AchievementItemProps) {
  return (
    <Card sx={{ borderRadius: '15px' }}>
      <CardContent>
        <Stack spacing={2}>
          <Stack direction="row" sx={{ alignItems: 'flex-start', justifyContent: 'space-between' }} spacing={3}>
            <Stack spacing={1}>
              <Typography color="text.secondary" variant="overline" sx={{ fontSize: '16px' }}>
                {title}
              </Typography>
              <Typography variant="h4" sx={{ color: 'primary.main' }}>
                {value}
              </Typography>
            </Stack>
            <Avatar sx={{ backgroundColor: 'secondary.main', height: '60px', width: '60px', color: 'white' }}>
              {icon}
            </Avatar>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}
